import { useEffect } from 'react';

/**
 * creates and cleans up a window event listener
 * @param {String} type type of event
 * @param {Function} callback function ran when event is triggered
 */
export const useCreateEventListener = (type, callback) => {
  useEffect(() => {
    window.addEventListener(type, callback);
    return () => {
      window.removeEventListener(type, callback);
    };
  }, []);
};
